module.exports = __webpack_public_path__ + "images/emoji/bow.2a2582096ab18df310c6.png";